import Header from "./components/Header";
import SupportCards from "./components/SupportCards";
import TopicSection from "./components/TopicSection";
import Footer from "./components/Footer";
import { subscriptionCards, billingCards } from "@/mocks/help-center";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cream via-white to-ice relative">
      <div className="relative z-10">
        <Header />
        <main className="max-w-6xl mx-auto px-4 sm:px-8 py-12 md:py-16 space-y-16 md:space-y-24">
          <SupportCards />
          <TopicSection
            title="SUBSCRIPTION MANAGEMENT"
            description="Manage your subscription settings, understand renewal policies, and resolve service delivery issues."
            cards={subscriptionCards}
          />
          <TopicSection
            title="BILLING & PAYMENTS"
            description="Resolve billing inquiries, track refunds, and get help with unrecognized charges on your account."
            cards={billingCards}
          />
        </main>
        <Footer />
      </div>
    </div>
  );
}